import React from "react";
import {KatBadge, KatBox, KatDivider, KatExpander} from "@amzn/katal-react";
import {useTranslation} from "react-i18next";
import {IEvent} from "src/context/models/Event";
import {capitalizeFirstLetter} from "src/common/utils/commonUtil";
import {isSpectrumHubSite} from "src/common/utils/dashboardUtils";
import {getFormattedUTCDateTime, getUTCDate} from "src/common/utils/dateUtils";
import {UpdateEventButton} from "src/components/healthDashboard/editableView/UpdateEventButton";

type Props = {
    event: IEvent
};

export const HistoricalEventCard: React.FC<Props> = ({
                                                         event
                                                     }) => {
    const {t} = useTranslation();
    if (!event.end || !event.lastUpdatedAt) {
        console.error("Historical events need end and last update date");
        return null;
    }

    return (
        <>
            <KatExpander className="historical-event" label={`${t("Resolved -")} ${capitalizeFirstLetter(event.section)}`}>
                <div slot="badge">
                    <KatBadge label={`${getUTCDate(event.start)}`}/>
                </div>
                <KatBox variant="white-shadow">
                    <div className="event-card-title">
                        <p><b>{`${event.summary}`}</b></p>
                        <p>{` : ${getFormattedUTCDateTime(event.start)} - ${getFormattedUTCDateTime(event.end)}`}</p>
                    </div>
                    <KatDivider variant="nordic"/>
                    <p>
                        {event.description}
                    </p>
                    <p>
                        <i>
                            {`${event.lastModifiedBy
                                ? `${t("Last updated by -")} ${event.lastModifiedBy + " : "}`
                                : `${t("Last update -")}`}
                        ${getFormattedUTCDateTime(event.lastUpdatedAt)}`}
                        </i>
                    </p>
                    {isSpectrumHubSite() ?
                        <UpdateEventButton event={event} section={event.section} operation={event.operation}/>
                        : null}
                </KatBox>
            </KatExpander>
            <KatDivider variant="nordic" />
        </>
    );
}